import React, { useState, useEffect } from 'react'
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";

const FacultyModal = ({ show, onClose, row, OnUpdateFaculty }) => {
    const { register, handleSubmit, watch, formState: { errors }, unregister, reset } = useForm();
    useEffect(() => {
        if (show) {
            reset(row)
        }
    }, [show]);
    const onSubmit = data => {
        data.facultyId = row.faculty._id;
        data._id = row._id;
        OnUpdateFaculty(data);
    };
    return (
        <>
            <Modal show={show} onHide={() => onClose()} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit faculty details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3" controlId="branch">
                            <Form.Label>Subject name</Form.Label>
                            <Form.Control type="text" defaultValue={row.name} disabled={true} {...register("name")} placeholder="Enter subject name" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="branch">
                            <Form.Label>Lecturer name</Form.Label>
                            <Form.Control type="text" defaultValue={row.faculty.firstName} {...register("faculty.firstName")} placeholder="Enter hod name" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="years">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" defaultValue={row.faculty.email} {...register("faculty.email")} placeholder="HOD email" />
                        </Form.Group>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Button className="modalbutton" variant="primary" type="submit">
                                Save
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FacultyModal



